import React, { Fragment } from 'react';
import { ShipmentStatus } from '../../../../orders/order';

const ShipmentBadgeComponent = ({ shipment }) => (
  <Fragment>
    {shipment.status === ShipmentStatus.Scheduled && (
      <span className="badge text-bg-secondary">Scheduled</span>
    )}
    {shipment.status === ShipmentStatus.Confirmed && (
      <span className="badge text-bg-primary">Completion Date Confirmed</span>
    )}
    {shipment.status === ShipmentStatus.Shipped && (
      <span className="badge text-bg-success">Shipped</span>
    )}
  </Fragment>
);

export default ShipmentBadgeComponent;
